import "./SidebarContainer.scss";

export default function SidebarContainer({
  header,
  children,
  body,
  footer,
}: {
  header?: any,
  children?: any;
  body?: any;
  footer?: any;
}) {
  return (
    <div id="sidebar-container" className="sidebar-container">
      {header ?
        <div className="sidebar-header">{header}</div> : ""
      }
      <div id="sidebar-content" className="sidebar-content pt-24">
        {body}{children}
      </div>
      {footer ?
        <div className="sidebar-footer">{footer}</div> : ""
      }
    </div>
  );
}
